export default "__VITE_ASSET__CUca_gJA__"